export enum FavoriteTypeEnum {
    StandardMedicine = 1,
    NonStandardMedicine = 2,
    Exam = 3,
}